module.exports = __webpack_public_path__ + "img/112-76c3a7.png";